module.exports = __webpack_public_path__ + "static/media/page5-1.2669139d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kitcut-footer--pages-images/page5-1.png
// module id = 1663
// module chunks = 0